/**
 * Build the lookup tables used while preparing the canvas render.
 *
 * Keeping this work linear avoids repeatedly scanning every node for every
 * relationship and every relationship for every node on large maps.
 */
export function buildMindMapRenderIndex(nodes = [], relationships = []) {
  const safeNodes = Array.isArray(nodes) ? nodes : [];
  const safeRelationships = Array.isArray(relationships) ? relationships : [];
  const nodesById = new Map();
  const childrenByParentId = new Map();

  for (const node of safeNodes) {
    if (!node?.id) continue;
    nodesById.set(node.id, node);
  }

  for (const relationship of safeRelationships) {
    if (!relationship?.parentId || !relationship?.childId) continue;
    const child = nodesById.get(relationship.childId);
    if (!child) continue;

    const children = childrenByParentId.get(relationship.parentId);
    if (children) {
      children.push(child);
    } else {
      childrenByParentId.set(relationship.parentId, [child]);
    }
  }

  return {
    nodesById,
    childrenByParentId,
  };
}
